import { ColumnType } from 'antd/es/table'

import { InvestigationTestSupplyEnrichedDto } from 'src/api/requests'
import { useLocales } from 'src/locales'

export const useSuppliesColumns = () => {
  const { t } = useLocales()

  const columns: ColumnType<InvestigationTestSupplyEnrichedDto>[] = [
    {
      key: 'Name',
      title: t('analysis.add_test.consumable_materials'),
      render: (_, { internationalName, product }) =>
        `${product?.name} - ${internationalName?.name}`
    },
    {
      key: 'unit',
      title: t('common.unit'),
      dataIndex: ['unit', 'name']
    },
    {
      key: 'quantity',
      title: t('common.quantity'),
      dataIndex: 'quantity'
    }
  ]

  return { columns }
}
